  export const validateEmail = email => {
    var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };
  
  export const validateUrl = input => {
    let regex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return regex.test(input);
  };
  
  export const validatePassword = input => {
    let regex = /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/;
    return regex.test(input);
  };
  export const validateForm = (fields) => {
  const emptyFields = fields.filter(field => {
    return (
      field?.value === "" ||
      field?.value === false ||
      field?.value === null ||
      field?.value === undefined
    );
  });

  
  if (emptyFields.length > 0) {
    // const fieldNames = emptyFields.map(field => field.key).join(", ");
    const customMessages = emptyFields
      .map(field => field.message || `${field.key} is required!`);
    const plural = emptyFields.length > 1;
 
    
    return {
      isValid: false,
      message: customMessages.join("\n"),
      missing: emptyFields.map(field => field.key),
    };
  }

  return { isValid: true };
};